import type { IPerson, IPersonApi } from 'src/interfaces';

export const mapApiToPerson = ({ lastname, firstname, middlename = '' }: IPersonApi): IPerson => ({
  lastName: lastname,
  firstName: firstname,
  middleName: middlename,
});
